<ng-template #portal>
    <div class="toast-wrapper">
        @for (toast of toasts; track toast.id) {
            <mat-card class="toast mat-elevation-z24" [@fade] [ngClass]="'toast-' + getTypeClass(toast.type)">
                <mat-card-content class="toast-content">
                  <span class="toast-icon">
                    <mat-icon class="material-icons-outlined" fontIcon="{{getTypeIcon(toast.type)}}"></mat-icon>
                  </span>
                  <div class="toast-message">
                    <!-- <strong>Info</strong> -->
                    <p>{{toast.message}}</p>
                  </div>
                  <button mat-icon-button aria-label="Close Toast" class="toast-button" (click)="removeToast(toast.id)">
                    <mat-icon>close</mat-icon>
                </button>
                </mat-card-content>
              </mat-card>
        }
    </div>
</ng-template>